import React, { FC, useState } from 'react';
import ButtonPrimary from '../../atoms/button-primary/button-primary';
import Modal from '../modal/modal';
import { BasketBackOrderConfirmationLabelsType } from '../../../models/basket-back-order-confirmation-labels-type';

interface Props {
  onContinueWithBackorder: () => void;
  onAmend: () => void;
  onContinueWithClear: () => void;
  labels: BasketBackOrderConfirmationLabelsType;
}

const BasketBackOrderConfirmation: FC<Props> = ({
  onContinueWithBackorder,
  onAmend,
  onContinueWithClear,
  labels: {
    outOfStockPopupAmendOrderButtonText,
    outOfStockPopupAmendOrderDescription,
    outOfStockPopupBackOrderButtonText,
    outOfStockPopupBackOrderDescription,
    outOfStockPopupDescription,
    outOfStockPopupHeading,
    outOfStockPopupInStockButtonText,
    outOfStockPopupInStockDescription,
  },
}) => {
  const [actionSelected, setActionSelected] = useState<boolean>(false);

  return (
    <Modal>
      <div className="flex flex-col space-y-8">
        <div className="flex flex-col space-y-2 max-w-sm">
          <h4 className="page-heading-four">{outOfStockPopupHeading}</h4>

          {outOfStockPopupDescription && (
            <p className="text-grey-600">{outOfStockPopupDescription}</p>
          )}
        </div>

        <div className="divide-grey-100 divide-y flex flex-col space-y-5">
          <div className="border-grey-100 border-t flex flex-wrap lg:flex-nowrap space-y-2 lg:space-y-0 lg:space-x-12 justify-between pt-5">
            <p className="w-full lg:w-auto">
              {outOfStockPopupBackOrderDescription}
            </p>

            <div className="flex w-full lg:w-64">
              <ButtonPrimary
                color="turquoise"
                className="flex-grow"
                name={outOfStockPopupBackOrderButtonText}
                disabled={actionSelected}
                onClick={() => {
                  setActionSelected(true);
                  onContinueWithBackorder();
                }}
              />
            </div>
          </div>

          <div className="flex flex-wrap lg:flex-nowrap space-y-2 lg:space-y-0 lg:space-x-12 justify-between pt-5">
            <p className="w-full lg:w-auto">
              {outOfStockPopupAmendOrderDescription}
            </p>

            <div className="flex w-full lg:w-64">
              <ButtonPrimary
                className="flex-grow"
                name={outOfStockPopupAmendOrderButtonText}
                disabled={actionSelected}
                onClick={() => {
                  setActionSelected(true);
                  onAmend();
                }}
              />
            </div>
          </div>

          <div className="flex flex-wrap lg:flex-nowrap space-y-2 lg:space-y-0 lg:space-x-12 justify-between pt-5">
            <p className="w-full lg:w-auto">
              {outOfStockPopupInStockDescription}
            </p>

            <div className="flex w-full lg:w-64">
              <ButtonPrimary
                className="flex-grow"
                color="black"
                name={outOfStockPopupInStockButtonText}
                disabled={actionSelected}
                onClick={() => {
                  setActionSelected(true);
                  onContinueWithClear();
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default BasketBackOrderConfirmation;
